import { Icon, IconProps } from '@chakra-ui/react';

export function InternalPayflipLogo(props: IconProps): JSX.Element {
  return (
    <Icon
      width="337"
      height="102"
      viewBox="0 0 337 102"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <title>Payflip</title>
      <path
        d="M50 81.5C67.1208 81.5 81 67.6208 81 50.5C81 33.3792 67.1208 19.5 50 19.5C32.8792 19.5 19 33.3792 19 50.5C19 67.6208 32.8792 81.5 50 81.5Z"
        fill="#220A35"
      />
      <path
        d="M47.2822 39.9966C42.2294 39.9966 38.1301 45.3122 38.1301 47.7447V70.471H42.4622C45.1275 70.471 47.2822 68.3163 47.2822 65.651V39.9966Z"
        fill="url(#paint0_linear_1_81)"
      />
      <path
        d="M52.1698 30.5366H51.4416H51.4191H47.4399C42.9577 30.5366 39.2263 33.6974 38.3328 37.9169C38.2127 38.5025 38.1301 39.7187 38.1301 39.7187V47.4744C38.1301 47.4744 38.8809 42.782 44.8647 40.6572C46.4188 40.1092 48.0555 39.8464 49.7073 39.8464H50.1352H51.4266H51.4491H52.2374C54.7901 39.8464 56.8623 41.9186 56.8623 44.4712C56.8623 47.0239 54.7901 49.0961 52.2374 49.0961H51.4491H51.4266H50.1352H45.4653C41.4186 49.0961 38.1376 52.377 38.1376 56.4238V58.3983V70.3584C38.1376 70.3584 39.2263 59.1191 49.1217 58.3983H50.1352H51.4266H51.4491H52.1774C59.8729 58.3983 66.112 52.1593 66.112 44.4637C66.0969 36.7757 59.8654 30.5366 52.1698 30.5366Z"
        fill="url(#paint1_linear_1_81)"
      />
      <path
        d="M258.944 19.5151H244.889C237.028 19.5302 232.321 21.76 230.594 26.9629C229.708 29.6357 231.105 32.8791 233.627 34.133H224.047V41.0027H229.378C229.641 41.0027 229.858 41.2129 229.858 41.4832V70.0356H237.419V41.4832C237.419 41.2204 237.637 41.0027 237.899 41.0027H244.979V34.133H237.419V32.6539C237.419 28.1417 240.054 26.3848 244.979 26.3848H250.911C251.173 26.3848 251.391 26.5951 251.391 26.8653V70.0431H258.951V19.9881H258.944V19.5151Z"
        fill="#220A35"
      />
      <path
        d="M212.853 34.1179L200.721 63.0533L190.465 34.1179H181.823L194.827 68.5866C196.524 68.5866 197.68 70.3134 197.019 71.875L193.078 81.2824H201.246L221.3 34.1179H212.853Z"
        fill="#220A35"
      />
      <path
        d="M178.91 51.0556C178.512 40.7849 169.713 32.6613 159.172 33.3671C150.005 33.9827 142.572 41.4456 142.001 50.5977C141.333 61.3189 149.847 70.2307 160.448 70.2307C164.367 70.2307 168.001 69.0069 170.997 66.9273C171.32 66.702 171.755 66.9198 171.755 67.3102V70.1557H178.933V51.0556H178.91ZM164.435 62.3775C155.936 65.3206 148.03 58.3758 149.254 50.0646C149.99 45.0794 154.112 41.1227 159.127 40.5521C165.929 39.7863 171.71 45.0794 171.748 51.7013V51.7614C171.748 56.4838 168.887 60.8384 164.435 62.3775Z"
        fill="#220A35"
      />
      <path
        d="M280.394 51.0556V81.5H287.572V67.3102C287.572 66.9198 288.015 66.702 288.33 66.9273C291.318 69.0069 294.952 70.2307 298.878 70.2307C309.48 70.2307 317.993 61.3264 317.325 50.5977C316.755 41.4456 309.314 33.9827 300.155 33.3671C289.614 32.6613 280.807 40.7849 280.417 51.0556H280.394ZM287.572 51.844V51.7088C287.609 45.5148 292.662 40.4845 298.878 40.4845C305.117 40.4845 310.193 45.5524 310.193 51.7764C310.193 58.0004 305.117 63.0682 298.878 63.0682C292.669 63.0682 287.609 58.0379 287.572 51.844Z"
        fill="#220A35"
      />
      <path
        d="M100.303 51.0556V81.5H107.48V67.3102C107.48 66.9198 107.923 66.702 108.239 66.9273C111.227 69.0069 114.86 70.2307 118.787 70.2307C129.388 70.2307 137.902 61.3264 137.234 50.5977C136.663 41.4456 129.223 33.9827 120.063 33.3671C109.522 32.6613 100.716 40.7849 100.325 51.0556H100.303ZM107.48 51.844V51.7088C107.518 45.5148 112.571 40.4845 118.787 40.4845C125.026 40.4845 130.101 45.5524 130.101 51.7764C130.101 58.0004 125.026 63.0682 118.787 63.0682C112.578 63.0682 107.518 58.0379 107.48 51.844Z"
        fill="#220A35"
      />
      <path
        d="M275.552 34.1479H267.954V70.1407H275.552V34.1479Z"
        fill="#220A35"
      />
      <path
        d="M271.76 26.4298H271.745C269.831 26.4298 268.284 24.8757 268.284 22.9687C268.284 21.0542 269.838 19.5076 271.745 19.5076H271.76C273.675 19.5076 275.221 21.0617 275.221 22.9687C275.221 24.8757 273.667 26.4298 271.76 26.4298Z"
        fill="#220A35"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_81"
          x1="38.1352"
          y1="55.2288"
          x2="47.2844"
          y2="55.2288"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0122996" stopColor="#FF2175" />
          <stop offset="0.0922144" stopColor="#FE287B" />
          <stop offset="0.6999" stopColor="#F95AA6" />
          <stop offset="1" stopColor="#F76DB6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_81"
          x1="44.2429"
          y1="50.4528"
          x2="64.9744"
          y2="50.4528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9C5E7" />
          <stop offset="0.1468" stopColor="#FAB4DB" />
          <stop offset="0.439" stopColor="#FB86BC" />
          <stop offset="0.8456" stopColor="#FE3E89" />
          <stop offset="1" stopColor="#FF2175" />
        </linearGradient>
      </defs>
    </Icon>
  );
}
